import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Onboarding from 'Views/Onboarding';
import OnboardingExperimental from 'Views/OnboardingExperimental';
import MainAppRoot from './MainAppRoot';
import paths from './paths';

const ContentRouter = () => {
  return (
    <Switch>
      {/* Routes */}
      <Route path={paths.welcome} component={Onboarding} />
      <Route path={paths.welcomeExperimental} component={OnboardingExperimental} />
      <Route component={MainAppRoot} />
    </Switch>
  );
};

export default ContentRouter;
